import { render, staticRenderFns } from "./personalFutrue.vue?vue&type=template&id=8a16a432&scoped=true&"
import script from "./personalFutrue.vue?vue&type=script&lang=ts&"
export * from "./personalFutrue.vue?vue&type=script&lang=ts&"
import style0 from "./personalFutrue.vue?vue&type=style&index=0&id=8a16a432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a16a432",
  null
  
)

export default component.exports